import {
	GetReturnLossRequest,
	GetReturnLossResponse,
} from '@/modules/promotion/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getReturnLossList } from '../../services'
import { ReturnLossQueryKeys } from '@/modules/promotion/keys'

export default function useQueryGetReturnLoss(
	payload: GetReturnLossRequest,
	props?: UseBaseQueryOptions<GetReturnLossResponse>,
) {
	return useQuery({
		queryKey: [ReturnLossQueryKeys.GetReturnLossList, payload],
		queryFn: () => getReturnLossList(payload),
		...props,
	})
}
